import { observer } from 'mobx-react';
import * as React from 'react';
import { RootContext } from 'RootProvider';
import LayoutController from './LayoutController';
import { CWEnv, initCWElements } from '@cw-elements/config';
import axios from 'axios';

const LayoutProvider = observer(() => {
  const { auth } = React.useContext(RootContext);

  initCWElements({
    environment: import.meta.env.VITE_APP_CW_ELEMENTS_ENV as CWEnv,
    token: auth.token.access_token,
    axiosInstance: axios,
    hostAppId: import.meta.env.VITE_APP_APP_ID,
  });

  return <LayoutController viewModel={auth} />;
});

export default LayoutProvider;
